import SectionHub from '@/components/docs/SectionHub';

export default function Docs04MacrosAndSignalsHub() {
  return <SectionHub sectionPath="04-macros-and-signals" />;
}
